import Vue from "vue";
import moment from "moment";

Vue.filter("time_ago", value => {
	return moment(value).fromNow();
});

Vue.filter("capitalize", value => {
	return value.charAt(0).toUpperCase() + value.slice(1);
});

Vue.filter("standard_date", value => {
	return moment(value).format("Do MMM, YYYY");
});

Vue.filter("standard_datetime", value => {
	return moment(value).format("Do MMM, YYYY LT");
});

Vue.filter("capitalise", value => {
	return value.charAt(0).toUpperCase() + value.slice(1);
});

Vue.filter("boolean", value => {
	return value ? "Yes" : "No";
});
